import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { NewsFeed, people } from "../../config/imagesLink";
import ThemedEmojiPicker from "../../components/ThemedEmojiPicker";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import { useTranslation } from "react-i18next";
const CommentReply = ({ 
  item, postId, setPostList, toggleReplyComment ,AllPostList, focusTrigger}) => {
  // console.log("postId", postId);
  const { t } = useTranslation();

  const sessionId = localStorage.getItem("sessionId");
  const profilPic = localStorage.getItem("profilPic");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const language = localStorage.getItem("Lang");

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************Post Comment  ************************//
  const [content, setContent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
   
  const [query, setQuery] = useState(""); // Store the full query
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const editorRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [SearchText, setSearchText] = useState("")
  const [suggestions, setSuggestions] = useState([]);  
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([])      
  
  const extractDynamicValues = (comment, existingValues) => {
  const newDynamicValues = [];
  let modifiedComment = comment;
  // Extract all tags with symbol
  const matches = [...comment.matchAll(/([#@])(\w+)/g)];

  // Get the current max dVno
  let currentMaxDVno = existingValues.reduce(
    (max, item) => (item.dVno && Number(item.dVno) > max ? Number(item.dVno) : max),
    0
  );

  matches.forEach(match => {
     const fullMatch = match[0];
    const symbol = match[1]; // # or @
    const tag = match[2];    // word part only
    const display = tag;

    // const alreadyExists = existingValues.some(item => item.display === display);
const type = symbol === "#" ? "Hashtag" : "UserMention";
    const alreadyExists = existingValues.concat(newDynamicValues).find(
      item => item.display === display && item.type === type
    );
    let dVno;
    if (alreadyExists) {
      dVno = alreadyExists.dVno;
    } else {
      currentMaxDVno += 1;
      dVno = currentMaxDVno;
      newDynamicValues.push({
        type,
        dVno,
        entity: display,
        display
      });
    }
     const regex = new RegExp(`\\${symbol}${tag}\\b`, "g");
    modifiedComment = modifiedComment.replace(regex, `{${dVno}}`);
    // if (!alreadyExists) {
    //   currentMaxDVno += 1;
    //   newDynamicValues.push({
    //     type: symbol === "#" ? "Hashtag" : "UserMention",
    //     dVno: currentMaxDVno,
    //     entity: "Hashtag" ? display : symbol,
    //     display: display
    //   });
    // }
  });
 const finalDynamicValues = [...existingValues, ...newDynamicValues];
  // return [...existingValues, ...newDynamicValues];
   return {
    formattedComment: modifiedComment,
    dynamicValues: finalDynamicValues
  };
};


  const postData = async () => {
    const { formattedComment, dynamicValues } = extractDynamicValues(postInputValue, postDynamicValues);

    const postdatadetails = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntId: item.pstCmntId, // comment ID to which reply is being posted
      reply: content,
      // reply: formattedComment,
      // dynamicValues: dynamicValues
      dynamicValues: [],
            langKey: language === "en" ? "" : language,

 
    };
    
    console.log("setPostList", setPostList);
    
    if (content === "") {
      setWarningToastMessage("Please Add the Comment");
      setShowWarningToast(true);
      return;
    }
  
    try {
      const res = await axios.post("PostAction/CommentReply", postdatadetails);
      setToastMessage(res.data.message);
      setShowToast(true);
      toast.success(res.data.message);
      toggleReplyComment(); // Hide reply input
      setContent(""); // Clear input
  
      const responseData = res.data.responseData;
  
      const newReply = {
        pstCmntRplyId: responseData.pstCmntRplyId,
        reply: responseData.reply,
        // dynamicValues: postDynamicValues,  
        userName: responseData.userName,
        userAvatar: profilPic,
        useruid: responseData.useruid,
        creationTime: responseData.creationTime,
        isOwned: true,
        replyCount: 0,
        likeCount: 0,
      };
  
      // console.log("newReplynewReply", newReply);
      
      // Update postList immediately
      setPostList((prevList) =>
        prevList.map((post) => {
          console.log("POst List==>",post)
          if (post?.postInfo?.postId === postId) {
            const updatedComments = post.postInfo.comments.map((comment) => {
              if (comment.pstCmntId === item.pstCmntId) {
                return {
                  ...comment,
                  commentsReplies: [newReply, ...(comment.commentsReplies || [])],
                  replyCount: (comment.replyCount || 0) + 1,
                };
              }
              return comment;
            });
  
            return {
              ...post,
              postInfo: {
                ...post.postInfo,
                comments: updatedComments,
              },
            };
          }
          return post;
        })
      );
    } catch (error) {
      console.log(error);
      
      setErrorToastMessage(error.message);
      setShowErrorToast(true);
    }
  };
  
  const handleKeyPress = () => {
    postData();
  };
  const handleEmojiClick = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const handleEmojiClose = () => {
    setShowEmojiPicker(false);
  };
  //************************Post Comment  ************************//
  // const profilPic = localStorage.getItem("profilPic");
  const guestModeData = localStorage.getItem("guestMode");


   //************************Post Comment  ************************//
  // Handle typing in textarea
  const handleChange = (e) => { 
    const value = e.target.value;
    const caret = e.target.selectionStart;

    setContent(value);
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(({ type, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      return value.includes(fullMention);
    });

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1
    }));

    setPostDynamicValues(reassignedDynamicValues);
  
    const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, reassignedDynamicValues);
    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const handleKeyDown = (e) => {
  if (e.key === "Enter" || e.key === " " || e.key === "Tab") {
    setShowSuggestions(false);
  }
};


  const handleTextChange = async (content, delta, source, editor) => {
    setContent(content);
    const cursorPosition = editor?.getSelection()?.index || 0;

    const textBeforeCursor = editor?.getText(0, cursorPosition);
    console.log("Text Before Cursor:", textBeforeCursor);

    // ✅ Updated regex: capture '@' or '#' followed by 0+ word chars
    const match = textBeforeCursor?.match(/([@#])(\w*)$/);
    console.log("Match Found:", match);

    if (!match) {
      setShowSuggestions(false);
      return;
    }

    const triggerChar = match[1]; // '@' or '#'
    const query = match[2];       // typed word after trigger
    console.log("Detected Trigger:", triggerChar, "Query:", query);

    const type = triggerChar === '@' ? "UserMention" : "Hashtag";
    setMentionType(type);

    // ✅ Only fetch if query length > 0 (after '@' or '#')
    if (!query) {
      setShowSuggestions(false);
      return;
    }

    // ✅ Debounce fetchSuggestions
    if (typingTimeout) clearTimeout(typingTimeout);
    const newTimeout = setTimeout(() => {
      fetchSuggestions(query, type);
    }, 500);
    setTypingTimeout(newTimeout);
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    const textarea = document.getElementById("commentTextArea");
    if (textarea) {
      textarea.setSelectionRange(cursorPosition, cursorPosition);
      textarea.focus();
    }
  }, [cursorPosition]);

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.focus();
      const textLength = editorRef.current.value?.length || 0;
      editorRef.current.setSelectionRange(textLength, textLength);
    }
  }, [focusTrigger]);


  const insertMention = (suggestion, userUid) => {
    const input = editorRef.current;  // Normal input or textarea
    if (!input) return;

    input.focus();

    const cursorPosition = input.selectionStart;
    const textBeforeCursor = input.value.slice(0, cursorPosition);
    const textAfterCursor = input.value.slice(cursorPosition);

    // Match @ or # mention before the cursor
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Insert mention at cursor position
    const updatedText =
      textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

    input.value = updatedText;
    setContent(updatedText);

    const newCursorPosition = startIndex + mentionText.length;

    // Set cursor position after inserted mention
    setTimeout(() => {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    // Replace @mention / #hashtag with {dVno}
    let modifiedText = updatedText;

    updatedPostDynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    setPostInputValue(`${modifiedText.trim()}`);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }; 
  

  return (
    <>
      {guestModeData === "true" ? (
        ""
      ) : (
        <div className="ReplyComment mt-2">
          <div className="commentArea ">
            <div className="ImgAvatar1">
              <img src={profilPic} alt="" style={{ borderRadius: "50px" }} />
            </div>
            <div className="commentBox">
              <input
              style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
              ref={editorRef}
              autoFocus
              className="me-2 ps-2"
                type="text"
                placeholder={t("Newsfeed.Write your comment")}
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                }}
                // onChange={handleChange}

                 onKeyDown={handleKeyDown}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleKeyPress();
                  }
                }}
              />
               {showSuggestions && (
                  <ul style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    width: "100%",
                    listStyle: "none",
                    padding: "5px",
                    marginTop: "5px",
                    zIndex: 100,
                    maxHeight: '250px',
                    overflowY: 'auto'
                  }}>
                    {mentionType === "Hashtag" ? <li
                      onMouseDown={(e) => {
                        e.preventDefault(); // Prevent editor blur
                        insertMention(
                          SearchText,
                          null
                        );
                      }}
                      className="suggestion-item"
                    >
                      <span>{SearchText ? `#${SearchText}` : ''}</span>
                    </li> : null}
                    {suggestions.map((item, index) => (
                      <li
                        key={index}
                        onMouseDown={(e) => {
                          e.preventDefault(); // Prevent editor blur
                          insertMention(
                            mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                            mentionType === "UserMention" ? item?.userUid : null
                          );
                        }}
                        className="suggestion-item"
                      >
                        {mentionType === "UserMention" ? (
                          <>
                            <img
                              src={item?.avatar}
                              alt={item?.entityName}
                              className="avatar"
                            />
                            <span>{item?.entityName}</span>
                          </>
                        ) : (
                          <span>#{item?.hashTag}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              <div>
                <AddReactionSharpIcon
                  className="material-symbols-sharp me-2 ms-1"
                  onClick={handleEmojiClick}
                  style={{ cursor: "pointer" }}
                />

                <SendSharpIcon
                  className="material-symbols-sharp"
                  onClick={() => postData()}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
          {showEmojiPicker && (
            <div className="HuzEmojiPickerChangeColor">
              <ThemedEmojiPicker
                onEmojiClick={(e, emojiObject) => {
                  setContent(content + e.emoji);
                  setShowEmojiPicker(false);
                }}
              />
              <div
                className="emoji-close"
                onClick={handleEmojiClose}
                style={{ cursor: "pointer" }}
              >
                <CloseSharpIcon className="material-symbols-sharp" />
              </div>
            </div>
          )}
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentReply;
